import { NavLink, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { useTouchHandlers } from '../../hooks';
import './Navigation.css';

interface NavigationProps {
  isMobileMenuOpen: boolean;
  onToggleMobileMenu: () => void;
}

export const Navigation = ({ isMobileMenuOpen, onToggleMobileMenu }: NavigationProps) => {
  const location = useLocation();

  // Touch handlers for mobile menu - swipe right to close
  const menuTouchRef = useTouchHandlers({
    onSwipeRight: () => {
      if (isMobileMenuOpen) {
        onToggleMobileMenu();
      }
    },
    enableHaptic: true,
  });

  // Close mobile menu when route changes
  useEffect(() => {
    if (isMobileMenuOpen) {
      onToggleMobileMenu();
    }
  }, [location.pathname]);

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname]);

  return (
    <nav className="navigation">
      <button
        className="navigation__hamburger mobile-only"
        onClick={onToggleMobileMenu}
        aria-label="Toggle menu"
        aria-expanded={isMobileMenuOpen}
      >
        <span className="navigation__hamburger-line"></span>
        <span className="navigation__hamburger-line"></span>
        <span className="navigation__hamburger-line"></span>
      </button>

      <ul 
        ref={menuTouchRef as any}
        className={`navigation__list ${isMobileMenuOpen ? 'navigation__list--open' : ''}`}
      >
        <li className="navigation__item">
          <NavLink
            to="/"
            className={({ isActive }) =>
              `navigation__link ${isActive ? 'navigation__link--active' : ''}`
            }
          >
            Home
          </NavLink>
        </li>
        <li className="navigation__item">
          <NavLink
            to="/agents"
            className={({ isActive }) =>
              `navigation__link ${isActive ? 'navigation__link--active' : ''}`
            }
          >
            Agents
          </NavLink>
        </li>
        <li className="navigation__item">
          <NavLink
            to="/weapons"
            className={({ isActive }) =>
              `navigation__link ${isActive ? 'navigation__link--active' : ''}`
            }
          >
            Weapons
          </NavLink>
        </li>
        <li className="navigation__item">
          <NavLink
            to="/maps"
            className={({ isActive }) =>
              `navigation__link ${isActive ? 'navigation__link--active' : ''}`
            }
          >
            Maps
          </NavLink>
        </li>
      </ul>
    </nav>
  );
};
